import { render } from "./ShopBookingApprove.vue?vue&type=template&id=58518024&scoped=true"
import script from "./ShopBookingApprove.vue?vue&type=script&lang=js"
export * from "./ShopBookingApprove.vue?vue&type=script&lang=js"

import "./ShopBookingApprove.vue?vue&type=style&index=0&id=58518024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58518024"]])

export default __exports__